import { Button } from "antd"
import styled from "styled-components"

import Flex from "#blocks/Flex"
import { useUserContext } from "#contexts/UserContextProvider"
import { camelToWords } from "#utils/textFormatters"

const SBanner = styled.div`
  width: 100vw;
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  background-color: #fa8c16;
  color: white;
  font-weight: 600;
  font-size: 14px;
`

const RoleOverrideBanner = () => {
  const { isRoleOverrideActive, role, stopRoleOverride } = useUserContext()

  if (!isRoleOverrideActive) return null

  return (
    <SBanner>
      <Flex center gap={8}>
        <span>⚠️ Role Override Active:</span>
        <span>{camelToWords(role)}</span>
      </Flex>
      <Button size="small" onClick={stopRoleOverride} type="default">
        Stop Override
      </Button>
    </SBanner>
  )
}

export default RoleOverrideBanner
